module.exports = __webpack_public_path__ + "img/elementos de portada-08.6ffa290d.png";